import { FilteredCommand } from '../../core/model/command';
import { RentalObjectCategory } from '../model/const/enums';

export class RentalObjectFilteredCommand extends FilteredCommand {
  constructor(
    id: string,
    readonly excludedIds: string[],
    readonly includedIds: string[],
    readonly totalAffectedItemsControlValue: number,
    readonly category: RentalObjectCategory
  ) {
    super(id, excludedIds, includedIds, totalAffectedItemsControlValue);
  }
}
